import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ResultPaperForm from "../components/ResultPaperForm";
import { withRouter } from "react-router-dom";
import { publicPaper } from "../modules/result";

const ResultPaperContainer = ({ token, history }) => {
  const dispatch = useDispatch();
  const {
    publicPaperError,
    publicResultPaper,
    auth,
  } = useSelector(({ result, auth }) => ({
    publicPaperError: result.publicPaperError,
    publicResultPaper: result.publicPaper,
    auth: auth.auth
  }));
  const [clickLock, setClickLock] = useState(false);
  const [isPublic, setIsPublic] = useState(false);

  useEffect(() => {
    if (token) {
      dispatch(publicPaper({ token }));
      setIsPublic(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
   * publicSummary() / deviceSummary() 메소드는 public_result_table을 응답한다.
   * public_reuslt_table이 있다는 것은 정상적인 진단평가 플로우대로 동작한게 아니라는 뜻이다.
   * domainNames도 설정이 안되어있을 것이므로 domainNames를 설정해준다.
   */
  /*
   * 만약 진단평가의 플로우를 따라왔다면 solved_problems 객체가 존재할 것이다.
   * solved_problems 객체와 achieve 객체를 파라미터로 sumamry() 메소드를 호출해 result_table을 응답받늗나.
   */

  /*
   * 하단 버튼을 클릭했을 때 모달 팝업의 호출을 다루는 메소드
   * popupState의 값에 따라 모달 팝업을 다루는 Modal Container의 동작이 달라짐
   * 즉 모달 팝업의 팝업 여부가 달라짐
   */

  /*
   * isPublic state는 하단의 모달팝업 버튼의 출력 여부를 담당함
   * public_reuslt_table이냐, result_table이냐에 따라서 결과보기 페이지의 파라미터가 조금 달라짐
   */

  const ooResultClick = (e) => {
    e.preventDefault();
    history.push(`/diagnosis/result/${token}`);
  };

  return auth ? (
    <p>no</p>
  ) : (
      publicPaperError ? (
        <p>no</p>
      ) : (
      <ResultPaperForm 
        publicResultPaper={publicResultPaper}
        ooResultClick={ooResultClick} 
      />
      )
  );
};

export default withRouter(ResultPaperContainer);
